var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.vcData !== null)?_c('ShowRoute',{attrs:{"vc-route-item":_vm.vcData},on:{"close":_vm.onShowRouteClose}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }